import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en';
import am from '../locales/am';
import or from '../locales/or';

const savedLanguage = localStorage.getItem('language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      am: { translation: am },
      or: { translation: or },
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
